// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"ed2e23c3","159":"a41dc25f","398":"67ad55eb","773":"eef6e749","805":"69676382"}[chunkId] + ".chunk.js";
};